import React from 'react';
import useCareTeamMember from '../../../../../hooks/api/useCareTeamMember';
import CareTeamMemberHeader from '../../../../shared/CareTeam/CareTeamMemberHeader';
import HeaderContainer from '../../../../v2BaseComponents/HeaderContainer';

export type InviteCareTeamMemberHeaderOwnProps = {
    careTeamMemberId: string;
    profileId: string;
};

export type InviteCareTeamMemberHeaderProps = InviteCareTeamMemberHeaderOwnProps;

const InviteCareTeamMemberHeader: React.FC<InviteCareTeamMemberHeaderProps> = ({ careTeamMemberId, profileId }) => {
    const { careTeamMember, isLoadingCareTeamMember } = useCareTeamMember({
        careTeamMemberId,
        medicalProfileId: profileId,
    });

    if (!careTeamMember || isLoadingCareTeamMember) {
        return null;
    }

    return (
        <HeaderContainer>
            <CareTeamMemberHeader
                careTeamMember={careTeamMember}
                source={{
                    source: 'profile',
                    medicalProfileId: profileId,
                }}
                careTeamMemberId={careTeamMemberId}
            />
        </HeaderContainer>
    );
};

export default React.memo(InviteCareTeamMemberHeader);
